import { platformFetch, readEnvelope } from '../../platform/http';

export type FailureLogKind = 'image' | 'video' | 'llm';

export interface FailureLogListParams {
  kind?: FailureLogKind;
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
}

export interface FailureLogEntry {
  id: string;
  mediaType: FailureLogKind;
  createdAt: string;
  source?: string | null;
  jobId?: string | null;
  userId?: string | null;
  model?: string | null;
  mode?: string | null;
  stage?: string | null;
  channelId?: string | null;
  channelName?: string | null;
  provider?: string | null;
  status?: number | null;
  errorCode?: string | null;
  errorMessage: string;
  latencyMs?: number | null;
}

export interface FailureLogDetail extends FailureLogEntry {
  requestSummary?: string | null;
  rawResponse?: string | null;
}

export interface FailureLogPagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface FailureLogListResult {
  data: FailureLogEntry[];
  pagination: FailureLogPagination;
}

function queryString(params: FailureLogListParams): string {
  const query = new URLSearchParams();
  if (params.kind) query.set('mediaType', params.kind);
  if (params.page) query.set('page', String(params.page));
  if (params.limit) query.set('limit', String(params.limit));
  if (params.startDate) query.set('startDate', params.startDate);
  if (params.endDate) query.set('endDate', params.endDate);
  const value = query.toString();
  return value ? `?${value}` : '';
}

export const failureLogsAPI = {
  async list(params: FailureLogListParams = {}): Promise<FailureLogListResult> {
    const response = await platformFetch(`/admin/failure-logs${queryString(params)}`);
    const result = await readEnvelope<FailureLogListResult | FailureLogEntry[]>(response, '加载失败日志失败');

    if (Array.isArray(result)) {
      return {
        data: result,
        pagination: {
          page: params.page ?? 1,
          limit: params.limit ?? result.length,
          total: result.length,
          totalPages: 1,
        },
      };
    }

    return result;
  },

  async getDetail(id: string): Promise<FailureLogDetail> {
    const response = await platformFetch(`/admin/failure-logs/${encodeURIComponent(id)}`);
    return readEnvelope<FailureLogDetail>(response, '加载失败日志详情失败');
  },
};
